module.exports = __webpack_public_path__ + "media/images/athletes/2389-6d6bb7a57a42e9a55c35662ff935bc90.png";